export type LastSyncKey = string;

type LastSyncMap = Record<string, string>;

const STORAGE_KEY = "operatorv4:lastSync";

const readMap = (): LastSyncMap => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? (parsed as LastSyncMap) : {};
    } catch {
        return {};
    }
};

const writeMap = (map: LastSyncMap) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
};

export const lastSyncHelper = {
    set(key: LastSyncKey, value: string) {
        const map = readMap();
        map[key] = value;
        writeMap(map);
    },

    get(key: LastSyncKey, defaultValue: string | null = null): string | null {
        const map = readMap();
        return map[key] ?? defaultValue;
    },

    clear(key?: LastSyncKey) {
        if (!key) {
            localStorage.removeItem(STORAGE_KEY);
            return;
        }
        const map = readMap();
        delete map[key];
        writeMap(map);
    },

    all(): LastSyncMap {
        return readMap();
    },
};
